// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YS52","question":"styles_question__HnfkY","description":"styles_description__NZeF4"};